import * as S from './ScrapNhisFullsheet.styled';
import {
  Bottomsheet,
  Button,
  CheckboxItem,
  HeadTitle,
  SpacerSection,
  // Tmd14,
  Spacer,
} from 'oui';
import React from 'react';
import scrap_doc from '../../../assets/images/feature/feature-scrap-doc.png';
import scrap_doc_loading from '../../../assets/gif/scrap_doc_loading.gif';
import scrap_doc_empty from '../../../assets/images/feature/feature-scrap-doc-empty.png';
import { FlexBox, FloatingBox, SideBox } from '../../etc/LBox/LBox';
import { TERM_SCRAP_NHIS } from '../../../application/staticData/terms';
import { useTermCheck } from '../../../application/hooks/useTermCheck';
import { useTermFullsheet } from '../../../application/hooks/useTermFullsheet';
import TermFullSheet from '../../feedback/TermFullSheet/TermFullSheet';

const ScrapNhisFullsheet = (props: any) => {
  const {
    isOpen,
    onClickClose,
    onClickSubmitReady,
    onClickSubmitFail,
    // onClickCustomInput,
    state,
  } = props ?? {};
  const termFullsheet = useTermFullsheet();
  const termCheck = useTermCheck(TERM_SCRAP_NHIS, 'all');

  // const state: any = 'loading';
  const { headTitle, img, button, cancelBtn, shouldRenderTerm } = (() => {
    let headTitle = {
      title: '',
      subTitle: '',
    };

    let img = {
      src: '',
    };

    let button = {
      has: false,
      onClick: () => {},
      text: '',
    };

    let cancelBtn = {
      has: false,
      onClick: () => {},
      text: '취소',
    };

    const shouldRenderTerm =
      state === 'initial' || state === 'ready' || state === 'canceled';

    if (shouldRenderTerm) {
      headTitle.title = 'PASS 인증서를 활용해보세요';
      headTitle.subTitle =
        '정확하고 간편하게 정보 입력이 가능해요';
      img.src = scrap_doc;
      button.has = true;
      button.onClick = onClickSubmitReady;
      button.text = '인증서 불러오기';
      cancelBtn.has = true;
      cancelBtn.onClick = onClickClose;
    } else if (state === 'loading') {
      headTitle.title = 'PASS 인증서를 통해\n정보를 불러오고 있어요';
      headTitle.subTitle = '';
      img.src = scrap_doc_loading;
      button.has = false;
      button.onClick = () => {};
      button.text = '';
      cancelBtn.has = false;
    } else if (state === 'failed') {
      headTitle.title = '정보를 불러오지 못했어요';
      headTitle.subTitle = '직접 입력을 통해 빠르게 조회를 도와드릴게요';
      img.src = scrap_doc_empty;
      button.has = true;
      button.onClick = onClickSubmitFail;
      button.text = '직접 입력하기';
      cancelBtn.has = false;
    }

    return {
      headTitle,
      img,
      button,
      shouldRenderTerm,
      cancelBtn,
    };
  })();

  return (
    <>
      <Bottomsheet isOpen={isOpen} backdrop={true}>
        <S.Wrap>
          <HeadTitle
            textTitle={headTitle.title}
            subTitle={headTitle.subTitle}
          />
          <Spacer size={'sm'} />
          <img
            src={img.src}
            alt={'scrap_doc'}
            style={{ width: '100%', height: 'auto' }}
          />

          {shouldRenderTerm && (
            <>
              <SideBox>
                <SpacerSection size={'lg'}>
                  {termCheck.checkList.map((item, idx) => (
                    <CheckboxItem
                      key={idx}
                      text={item.text}
                      isExpand={item.isExpand}
                      checked={item.checked}
                      onClickCheckBox={() => termCheck.toggleCheckBox(idx)}
                      onClickExpand={() => {
                        const item = termCheck.findItem(idx);
                        termFullsheet.open(item.text, item.path, item.termsCd);
                      }}
                    />
                  ))}
                </SpacerSection>

                {/*<SpacerSection size={'sm'}>*/}
                {/*  <S.CenterWrap>*/}
                {/*    <Tmd14 text={'직장인이 아니라면?'} color={'#9C9C9C'} />*/}
                {/*    <div style={{ height: '6px' }}></div>*/}
                {/*    <Button*/}
                {/*      color={'default'}*/}
                {/*      flexible={false}*/}
                {/*      configuration={'outlined'}*/}
                {/*      size={'md'}*/}
                {/*      state={'enabled'}*/}
                {/*      onClick={onClickCustomInput}*/}
                {/*    >*/}
                {/*      직접입력하기*/}
                {/*    </Button>*/}
                {/*  </S.CenterWrap>*/}
                {/*</SpacerSection>*/}
              </SideBox>

              {/*<Spacer size={'lg'} />*/}
              {/*<Spacer size={'lg'} />*/}
              {/*<Spacer size={'lg'} />*/}
            </>
          )}

          {button.has && (
            <FloatingBox>
              <FlexBox>
                {cancelBtn.has && (
                  <>
                    <div style={{flexShrink: 0, marginRight: 11}}>
                      <Button
                          configuration={'outlined'}
                          flexible={false}
                          onClick={cancelBtn.onClick}
                          children={'직접 입력'}
                      />
                    </div>
                  </>
                )}
                <Button
                  configuration={'contained'}
                  flexible={true}
                  onClick={button.onClick}
                  children={button.text}
                />
              </FlexBox>
            </FloatingBox>
          )}
        </S.Wrap>
      </Bottomsheet>
      <TermFullSheet
        isOpen={termFullsheet.isOpen}
        title={termFullsheet.title}
        path={termFullsheet.path}
        onClickClose={termFullsheet.close}
      />
    </>
  );
};

export default ScrapNhisFullsheet;
